<template>
	<div class="login-panel col xs-12 sm-12 md-6">
		<div v-if="!showRestForm" @keyup.enter="login">
			<div class="login-panel__title">{{maContent.ma11_1_1}}</div>
			<div class="login-panel__subhead">{{maContent.ma11_1_2}}</div>
			
			<div class="form ma-form">
				<input type="email" v-model="email" placeholder="Email Address">
				<input type="password" v-model="password" placeholder="Password">
				<button class="btn primary login" @click="login">{{maContent.ma11_1_3}}</button>							
			</div>
			<p>{{maContent.ma11_1_4}} <a @click="showRestForm = !showRestForm" href="#">here</a></p>
		</div>
		<div v-else>
			<div class="login-panel__title">{{maContent.ma11_1_5}}</div>	
			<div class="login-panel__subhead">{{maContent.ma11_1_6}}</div>
			<div class="form">
				<input type="email" v-model="resetEmail" placeholder="Email Address">
				<button class="btn primary" @click="resetPassword">{{maContent.ma11_1_7}}</button>
			</div>
			<p>Back to <a href="#" @click="showRestForm = !showRestForm">Login</a></p>
		</div>
	</div>
</template>

<script>
export default {
	data(){
		return {
			showRestForm : false,
			resetEmail : "",
			email : "",
			password : "",
		}
		
	},
	components : {
	

	},
	computed : {
		maContent(){
			return this.$store.getters.getBuildData;
			},
	
	},
	methods : {
		login(){

			if(this.email.length == 0){

				this.$toasted.error('Please enter a user email', {
                        theme: 'bubble',
                        position: 'bottom-center',
                        duration: 5000
                })
                return
			}

			if(this.password.length == 0){
				this.$toasted.error('Please enter a password', {
                        theme: 'bubble',
                        position: 'bottom-center',
                        duration: 5000
                })
                return
			}

			this.$toasted.show('loggin in...', {
				theme: 'bubble',
                position: 'bottom-center',
				duration: null
            })

			this.$store.dispatch('userLogin', {email : this.email, password : this.password})
			.then((response) => {
				this.$toasted.clear();
				if(response.confirmation != 'success'){
					this.$toasted.error(response.message, {
                        theme: 'bubble',
                        position: 'bottom-center',
                        duration: 5000
                	});
				}
				this.$router.push({path : '/create/quote-summary'})
				this.$toasted.success("Welcome", {
                    theme: 'bubble',
                    position: 'bottom-center',
                    duration: 5000
               	})
			})
			.catch((err) => {
				this.$toasted.clear();
				this.$toasted.error(err.message, {
                    theme: 'bubble',
                    position: 'bottom-center',
                    duration: 5000
                })
				
			})
		},
		resetPassword(){
			if(this.resetEmail.length == 0){

				this.$toasted.error('Please enter a user email', {
	                theme: 'bubble',
	                position: 'bottom-center',
	                duration: 5000
	            })
	            return
			}
			this.$toasted.show('Please wait...', {
				theme: 'bubble',
	            position: 'bottom-center',
				duration: null
	        })

			this.$store.dispatch('userResetPassword', {email : this.resetEmail})
			.then((response) => {
				this.$toasted.clear();
				if(response.confirmation == 'validation'){
					this.$toasted.error(response.message, {
						theme: 'bubble',
			            position: 'bottom-center',
						duration: 5000
			        })
				} else {
					this.$toasted.success(response.message, {
						theme: 'bubble',
			            position: 'bottom-center',
						duration: 5000
			        })
				}
			})
			.catch((err) => {
				this.$toasted.error(err.message, {
					theme: 'bubble',
		            position: 'bottom-center',
					duration: 5000
		        })
			})

		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/common/login/MALoginPanel.vue